var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "floorplan" }, [
    _c(
      "div",
      {
        staticClass: "floorplan-container",
        class: {
          "floorplan-dragging": _vm.isDragging,
          "floorplan-overflow-hidden": _vm.isDraggable || _vm.isResizable,
        },
        on: {
          touchstart: _vm.handleTouchStart,
          touchmove: _vm.handleTouchMove,
          touchend: _vm.handleTouchEnd,
          mousedown: _vm.handleDragStart,
          mousewheel: _vm.handleScroll,
          DOMMouseScroll: _vm.handleScroll,
        },
      },
      [
        _c(
          "span",
          {
            staticClass: "floorplan-inner",
            style: {
              transform: `translate(${_vm.interactX * _vm.floorplanScale}px, ${
                _vm.interactY * _vm.floorplanScale
              }px) scale(${_vm.floorplanScale})`,
            },
          },
          [
            _c(
              "icon",
              {
                staticClass: "floorplan-image",
                style: {
                  width: `${_vm.floorplanContainerWidth}px`,
                  height: `${_vm.floorplanContainerHeight}px`,
                },
                attrs: { "has-lazyload": true, image: _vm.floorplan },
              },
              [
                _c("floorplan-dots", {
                  attrs: {
                    ratio: _vm.floorplanContainerScale,
                    "ratio-rfe": _vm.floorplanContainerScaleRfe,
                    "x-offset": _vm.xOffset,
                    "y-offset": _vm.yOffset,
                    "activated-color": _vm.activatedColor,
                    scale: _vm.scaleOfDotsAndRange,
                    "floorplan-scale": _vm.floorplanScale,
                  },
                }),
                _vm._v(" "),
                _c("floorplan-range", {
                  attrs: {
                    ratio: _vm.floorplanContainerScale,
                    "ratio-rfe": _vm.floorplanContainerScaleRfe,
                    "x-offset": _vm.xOffset,
                    "y-offset": _vm.yOffset,
                    scale: _vm.scaleOfDotsAndRange,
                  },
                }),
              ],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.isResizable
          ? _c("i-repeat", {
              staticClass: "floorplan-zoom-in-container",
              attrs: {
                "li-class": "floorplan-zoom-in-item",
                items: _vm.zoomInButtons,
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function ({ item: button }) {
                      return [
                        _c("icon", {
                          class: button.className,
                          nativeOn: {
                            click: function ($event) {
                              return button.method.apply(null, arguments)
                            },
                          },
                        }),
                      ]
                    },
                  },
                ],
                null,
                false,
                3497879292
              ),
            })
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }